__turbopack_context__.v({
  "balanceCard": "WFrzvG_balanceCard",
  "bannerCard": "WFrzvG_bannerCard",
  "bannerTitle": "WFrzvG_bannerTitle",
  "benefitsList": "WFrzvG_benefitsList",
  "topUpBadge": "WFrzvG_topUpBadge",
  "topUpButton": "WFrzvG_topUpButton",
  "topUpCard": "WFrzvG_topUpCard",
  "topUpIcon": "WFrzvG_topUpIcon",
  "topUpTitle": "WFrzvG_topUpTitle",
});
